var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimImageNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.5,125.8,646.7,67.4A32.28,32.28,0,0,0,632.4,64H199.5a32,32,0,0,0-14.3,3.4L68.4,125.8A8,8,0,0,0,64,133V312a8,8,0,0,0,8,8H192V632a8,8,0,0,0,8,8h95.9l26.18-64H256V256H128V167.5L207.1,128h80.81a128,128,0,1,0,256,0h81L704,167.5V256H576V384h64V320H760a8,8,0,0,0,8-8V132.9A8.14,8.14,0,0,0,763.5,125.8ZM415.91,192a64,64,0,0,1-64-64h128A64,64,0,0,1,415.91,192Z",
    style: {
      fill: "#96a2b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.4,860.71,787.48,440.47a16,16,0,0,0-6.87-7.83L699.2,386.11a16,16,0,0,0-7.94-2.11H473.76a16,16,0,0,0-7.94,2.11L384.4,432.64a16,16,0,0,0-6.87,7.83L322.08,576,295.9,640,205.61,860.71a8,8,0,0,0,4.53,10.49l148.37,57.06V952a8,8,0,0,0,8,8h432a8,8,0,0,0,8-8V928.26L954.87,871.2A8,8,0,0,0,959.4,860.71ZM628.5,448l-46,99.64L576,533.54,536.52,448Zm-78,448h-128V829.41c0-8.95-12.46-11.15-15.52-2.73L390.51,872l-104-40,78.55-192,26.18-64,39.27-96,39.8-22.74L525.11,576l25.4,55Zm224-24L758,826.68c-3.06-8.42-15.52-6.22-15.52,2.73V896h-128V631L640,575.8l54.71-118.54L734.51,480l144,352Z",
    style: {
      fill: "#5b6673"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimImageNormal);
export default __webpack_public_path__ + "static/media/sim_image_normal.1b22e7d6a992b7d01ba60ff98008ef15.svg";
export { ForwardRef as ReactComponent };